import type { FaireProductEntity } from "../../entity_types/product";

export const p_9bjzspf5hp: FaireProductEntity = {
  token: "p_9bjzspf5hp",
  type: "product",
  name: "Eroded Teak Root Bowls",
  brandName: "Garden Age Supply",
  imageUrl:
    "https://cdn.faire.com/fastly/40ffdaa3e70aaf52d6af092dddbdddbba2adadad5f776de2d56df8f7ec919d39.jpeg",
  priceDollars: 19.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e7962384e18582d58004009a3d6b9b256911d9d4366d46e6811ee14684d4e872.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
